// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'eed81b22-3d02-4f64-a6d6-f861993aa4cb',
      type: 'Sprite',
      name: 'island',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_8_Island',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        name: 'LAKE',
        reward: {
          'Coin': 100,
          'BoosterUndo': 1,
        }
      }
    },
    {
      id: 'e194cb70-e7c8-47fd-9004-06e7ec6c03de',
      type: 'Sprite',
      name: 'chairsShadow',
      className: '',
      x: 16,
      y: -384,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 2,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_8_Chairs_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 1800,
        order: 5
      }
    },
    {
      id: 'd3e1f3a2-9f0b-4648-93a4-4d823c13df8b',
      type: 'Sprite',
      name: 'chairs',
      className: '',
      x: 26,
      y: -400,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_8_Chairs',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 1800,
        order: 5
      }
    },
    {
      id: 'ff466138-0a29-4198-b512-823330c181b6',
      type: 'Sprite',
      name: 'windturbineShadow',
      className: '',
      x: 160,
      y: -410,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 2,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_8_Wind_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 1800,
        order: 7
      }
    },
    {
      id: '66a44b02-3f70-4470-a453-c0e97a6c01e3',
      type: 'Sprite',
      name: 'windturbine',
      className: '',
      x: 205,
      y: -505,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_8_Wind',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 1800,
        order: 7
      }
    },
    {
      id: 'a824b4ad-1e3c-4816-bf87-4fe2872ff9ed',
      type: 'Sprite',
      name: 'houseShadow',
      className: '',
      x: -136,
      y: -288,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 2,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_8_House_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 2600,
        order: 3
      }
    },
    {
      id: 'ad5d001d-a0da-4077-ad15-3115eb416091',
      type: 'Sprite',
      name: 'house',
      className: '',
      x: -121,
      y: -388,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_8_House',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 2600,
        order: 3
      }
    },
    {
      id: '81bd03c0-075c-4c54-901c-d370543415bc',
      type: 'Sprite',
      name: 'picnicShadow',
      className: '',
      x: 200,
      y: -246,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 2,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_8_PicNic_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 1800,
        order: 2
      }
    },
    {
      id: '1977870c-e4d5-4c37-bd32-09045bc4698f',
      type: 'Sprite',
      name: 'picnic',
      className: '',
      x: 202,
      y: -289,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_8_PicNic',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 1800,
        order: 2
      }
    },
    {
      id: 'ec6ebb4e-4a31-4866-9a6e-2ee9a647f5ea',
      type: 'Sprite',
      name: 'swansShadow',
      className: '',
      x: -16,
      y: -173,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 2,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_8_Swan_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 1100,
        order: 4
      }
    },
    {
      id: '44046bb2-16e1-4c79-9323-8f80622c7e0c',
      type: 'Sprite',
      name: 'swans',
      className: '',
      x: -11,
      y: -190,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_8_Swan',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 1100,
        order: 4
      }
    },
    {
      id: 'cd7f5d10-175e-4822-a76d-8dc2767d5d85',
      type: 'Sprite',
      name: 'boatShadow',
      className: '',
      x: -140,
      y: -135,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 2,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_8_Boat_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 2600,
        order: 6
      }
    },
    {
      id: '1c5aea13-537a-464c-bfc0-d6c0326c13e6',
      type: 'Sprite',
      name: 'boat',
      className: '',
      x: -119,
      y: -135,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_8_Boat',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 2600,
        order: 6
      }
    },
    {
      id: 'f3e7e09f-61ef-4eec-a9b5-f11f701cd8c2',
      type: 'Sprite',
      name: 'buoysShadow',
      className: '',
      x: 202,
      y: -127,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 2,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_8_Buoys_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 1100,
        order: 1
      }
    },
    {
      id: '13257080-c28f-49ea-8f88-5f1a2afe4f00',
      type: 'Sprite',
      name: 'buoys',
      className: '',
      x: 209,
      y: -143,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_8_Buoys',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 1100,
        order: 1
      }
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  handleResize: false
} as const;

export class Diorama_8 {
  static raw = raw;
  root!: Container;
  island!: Sprite & { data: typeof raw['list'][1]['data'] };
  chairsShadow!: Sprite & { data: typeof raw['list'][2]['data'] };
  chairs!: Sprite & { data: typeof raw['list'][3]['data'] };
  windturbineShadow!: Sprite & { data: typeof raw['list'][4]['data'] };
  windturbine!: Sprite & { data: typeof raw['list'][5]['data'] };
  houseShadow!: Sprite & { data: typeof raw['list'][6]['data'] };
  house!: Sprite & { data: typeof raw['list'][7]['data'] };
  picnicShadow!: Sprite & { data: typeof raw['list'][8]['data'] };
  picnic!: Sprite & { data: typeof raw['list'][9]['data'] };
  swansShadow!: Sprite & { data: typeof raw['list'][10]['data'] };
  swans!: Sprite & { data: typeof raw['list'][11]['data'] };
  boatShadow!: Sprite & { data: typeof raw['list'][12]['data'] };
  boat!: Sprite & { data: typeof raw['list'][13]['data'] };
  buoysShadow!: Sprite & { data: typeof raw['list'][14]['data'] };
  buoys!: Sprite & { data: typeof raw['list'][15]['data'] };
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
